<template>
  <v-fade-transition mode="out-in">
    <router-view />
  </v-fade-transition>
</template>

<script>
import store from "@store";

export default {
  name: "App",
  components: {},
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // if the route changes...
      let user = localStorage.getItem("key_userObject");
      store.set("app/isLogined", user != null);
    },
  },
};
</script>

<style></style>
